/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.hero-banner' ).each( function( key, val ) {
        let image = $( this ).find( '.fit-image img' )[0];
        if ( $( this ).find( '.loop-video-container' ).length ) {
          image = $( this ).find( '.loop-video-container' )[0];
        }
        const height = $( this ).outerHeight();

        const snowBlast = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            end: 'bottom 90%',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'is-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'is-animated' ),
            // markers: true,
          },
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: 'bottom top',
            scrub: 0,
            // markers: true,
          },
        } );
        tl.to( image, {y: '10%', ease: 'linear'}, 0 );
        tl.to( image, {y: '10%', ease: 'linear'}, 0 );

        $( this ).find( '.announcements' ).slick( {
          dots: true,
          arrows: false,
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 8000,
        } );

        if ( $( val ).find( '.weather-widget' ).length ) {
          // Set up weather api with current lat long
          const apiKey = '0329609a6344d919b187bbe2e9bef2d4';
          const url = 'https://api.openweathermap.org/data/2.5/weather?lat=39.484268443531626&lon=-106.05717834527482&appid=' + apiKey;

          fetch( url )
              .then( ( response ) => response.json() )
              .then( ( data ) => {
                console.log( data );
                // spit out the precipitation chance for the closest next hour
                $( val ).find( '.weather-temperature' ).text( parseInt( ( data.main.temp - 273.15 ) * ( 9/5 ) + 32 ) + '°F' );
                $( val ).find( '.weather-wind' ).text( data.wind.speed + 'mph' );
                $( val ).find( '.weather-pressure' ).text( data.main.pressure + ' mb' );
                $( val ).find( '.weather-visibility' ).text( ( data.visibility / 1000 ) + 'km' );
                $( val ).find( '.weather-widget' ).addClass( 'is-loaded' );
              } )
              .catch( () => {
                console.error( 'Something went wrong' );
              } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
